import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import StatusMessage from '@/components/shared/status-message';
import { ERROR_FEEDBACK } from '@/utils/constants';

const MapConfigError: FC = () => {
  const { t } = useTranslation();

  return (
    <div className="fixed inset-0 top-9 overflow-y-auto bg-white">
      <div className="min-h-[90vh] flex items-center justify-center py-8">
        <StatusMessage
          type="error"
          title={t(ERROR_FEEDBACK.general)}
          description={t(ERROR_FEEDBACK.map.api)}
          showReloadButton
          onRetry={() => window.location.reload()}
        />
      </div>
    </div>
  );
};

export default MapConfigError;
